import { languageOptions } from '../config/constants';

let getEnglishOrdinal = (n: number) => {
  let mod100 = n % 100;
  if (mod100 >= 11 && mod100 <= 13) return `${n}th`;
  let mod10 = n % 10;
  if (mod10 === 1) return `${n}st`;
  if (mod10 === 2) return `${n}nd`;
  if (mod10 === 3) return `${n}rd`;
  return `${n}th`;
};

let copy = {
  languageName: {
    [languageOptions.english.key]: 'English',
    [languageOptions.spanish.key]: 'Español',
  },

  selectYourPreferredLanguage: {
    [languageOptions.english.key]: 'Select your preferred language.',
    [languageOptions.spanish.key]: 'Selecciona tu idioma preferido.',
  },

  offlineBanner: {
    [languageOptions.english.key]: "You're offline — some features will not work.",
    [languageOptions.spanish.key]: 'Estás sin conexión — algunas funciones no estarán disponibles.',
  },

  now: {
    [languageOptions.english.key]: 'Now',
    [languageOptions.spanish.key]: 'Ahora',
  },

  LastCategory: {
    [languageOptions.english.key]: 'Final category',
    [languageOptions.spanish.key]: 'Ultima categoria',
  },

  hasntStartedTheirBallot: {
    [languageOptions.english.key]: "hasn't started their ballot",
    [languageOptions.spanish.key]: 'no ha comenzado su balota',
  },

  DoneTapHereToReturnHome: {
    [languageOptions.english.key]: 'Done! Tap here to return home.',
    [languageOptions.spanish.key]: '¡Hecho! Toca aquí para terminar.',
  },

  In: {
    [languageOptions.english.key]: 'In',
    [languageOptions.spanish.key]: 'En',
  },

  Next: {
    [languageOptions.english.key]: 'Next',
    [languageOptions.spanish.key]: 'Siguiente',
  },

  From: {
    [languageOptions.english.key]: 'From',
    [languageOptions.spanish.key]: 'De',
  },

  day: {
    [languageOptions.english.key]: 'day',
    [languageOptions.spanish.key]: 'día',
  },

  hour: {
    [languageOptions.english.key]: 'hour',
    [languageOptions.spanish.key]: 'hora',
  },

  minute: {
    [languageOptions.english.key]: 'minute',
    [languageOptions.spanish.key]: 'minuto',
  },

  minutes: {
    [languageOptions.english.key]: 'minutes',
    [languageOptions.spanish.key]: 'minutos',
  },

  second: {
    [languageOptions.english.key]: 'second',
    [languageOptions.spanish.key]: 'segundo',
  },

  build: {
    [languageOptions.english.key]: 'Build',
    [languageOptions.spanish.key]: 'Versión',
  },

  gus: {
    [languageOptions.english.key]: 'Gus',
    [languageOptions.spanish.key]: 'Gustavo',
  },

  gameDesignAndCodeBy: {
    [languageOptions.english.key]: 'A once-a-year ballot game by',
    [languageOptions.spanish.key]: 'Un juego de votación anual por',
  },

  "Item": {
    [languageOptions.english.key]: 'Item',
    [languageOptions.spanish.key]: 'Item',
  },

  connectYourLetterboxd: {
    [languageOptions.english.key]: 'Connect your Letterboxd account to sync watched films.',
    [languageOptions.spanish.key]: 'Conecta tu cuenta de Letterboxd para sincronizar películas vistas.',
  },

  "connect": {
    [languageOptions.english.key]: 'connect',
    [languageOptions.spanish.key]: 'conectar',
  },

  "Letterboxd": {
    [languageOptions.english.key]: 'Letterboxd',
    [languageOptions.spanish.key]: 'Letterboxd',
  },

  "Letterboxd prompt": {
    [languageOptions.english.key]: 'Connect Letterboxd',
    [languageOptions.spanish.key]: 'Conectar Letterboxd',
  },

  "Letterboxd is unavailable right now": {
    [languageOptions.english.key]: 'Letterboxd is unavailable right now',
    [languageOptions.spanish.key]: 'Letterboxd no está disponible en este momento',
  },

  "Couldn't load your watched films and ratings": {
    [languageOptions.english.key]: "Couldn't load your watched films and ratings",
    [languageOptions.spanish.key]: 'No se pudieron cargar tus películas vistas y calificaciones',
  },

  "Letterboxd Activity": {
    [languageOptions.english.key]: 'Letterboxd Activity',
    [languageOptions.spanish.key]: 'Actividad de Letterboxd',
  },

  "Ballot": {
    [languageOptions.english.key]: 'Ballot',
    [languageOptions.spanish.key]: 'Balota',
  },

  "Items": {
    [languageOptions.english.key]: 'Items',
    [languageOptions.spanish.key]: 'Items',
  },

  "hidden": {
    [languageOptions.english.key]: 'hidden',
    [languageOptions.spanish.key]: 'oculto',
  },

  'Hide': {
    [languageOptions.english.key]: 'Hide',
    [languageOptions.spanish.key]: 'Ocultar',
  },

  'What\'s this?': {
    [languageOptions.english.key]: 'What\'s this?',
    [languageOptions.spanish.key]: '¿Qué es esto?',
  },

  findMeOn: {
    [languageOptions.english.key]: 'Find me on',
    [languageOptions.spanish.key]: 'Encuéntrame en',
  },
  Edit: {
    [languageOptions.english.key]: 'Edit',
    [languageOptions.spanish.key]: 'Editar',
  },

  'See more on Letterboxd': {
    [languageOptions.english.key]: 'See more on Letterboxd',
    [languageOptions.spanish.key]: 'Ver más en Letterboxd',
  },

  spanishTranslationBy: {
    [languageOptions.english.key]: 'Spanish translation by',
    [languageOptions.spanish.key]: 'Traducción al español por',
  },

  bugReportsQuestionsAndRequestsAreReceivedAt: {
    [languageOptions.english.key]:
      'Bug reports, questions, and requests are received at',
    [languageOptions.spanish.key]:
      'Recibimos informes de errores, preguntas, y peticiones en',
  },

  theOscarsAreLiveIn: {
    [languageOptions.english.key]: 'The Oscars are live in...',
    [languageOptions.spanish.key]: 'Los Oscars están en vivo en...',
  },

  theOscarsAreLive: {
    [languageOptions.english.key]: 'The Oscars are live...',
    [languageOptions.spanish.key]: 'Los Oscars están en vivo...',
  },

  nominationsAreAnnouncedIn: {
    [languageOptions.english.key]: 'Nominations announced in...',
    [languageOptions.spanish.key]: 'Las nominaciones se anuncian en...',
  },

  nominationsAreAnnounced: {
    [languageOptions.english.key]: 'Nominations announced...',
    [languageOptions.spanish.key]: 'Las nominaciones se anuncian...',
  },

  readMore: {
    [languageOptions.english.key]: 'Read more',
    [languageOptions.spanish.key]: 'Leer más',
  },

  welcomeTo: {
    [languageOptions.english.key]: 'Welcome to',
    [languageOptions.spanish.key]: 'Bienvenidos a',
  },
  letSGetYouSignedIn: {
    [languageOptions.english.key]: 'Sign in with...',
    [languageOptions.spanish.key]: 'Accede con...',
  },

  orContinueWithGoogle: {
    [languageOptions.english.key]: 'or, continue with Google',
    [languageOptions.spanish.key]: 'O continuar con Google',
  },

  'Incomplete Ballots 🥲': {
    [languageOptions.english.key]: 'Incomplete Ballots 🥲',
    [languageOptions.spanish.key]: 'Balota Incompletas 🥲',
  },

  ReleaseDate: {
    [languageOptions.english.key]: 'Release date',
    [languageOptions.spanish.key]: 'Fecha de lanzamiento',
  },
  RunTime: {
    [languageOptions.english.key]: 'Run time',
    [languageOptions.spanish.key]: 'Duración',
  },

  continueWithPhoneNumber: {
    [languageOptions.english.key]: 'Continue with phone number',
    [languageOptions.spanish.key]: 'Continuar con teléfono',
  },

  sorryWeCouldnTFindThePageYouWereLookingFor: {
    [languageOptions.english.key]:
      "Sorry, we couldn't find the page you were looking for.",
    [languageOptions.spanish.key]:
      'Lo sentimos, no pudimos encontrar la pagina solicitada.',
  },

  Me: {
    [languageOptions.english.key]: 'Me',
    [languageOptions.spanish.key]: 'Yo',
  },

  home: {
    [languageOptions.english.key]: 'Home',
    [languageOptions.spanish.key]: 'Principal',
  },

  newLeague: {
    [languageOptions.english.key]: 'New League',
    [languageOptions.spanish.key]: 'Nueva liga',
  },

  hi: {
    [languageOptions.english.key]: 'Hi',
    [languageOptions.spanish.key]: 'Hola',
  },

  yourBallotIsReadyToGo: {
    [languageOptions.english.key]: 'Your ballot is ready to go!',
    [languageOptions.spanish.key]: '¡Tu balota está lista!',
  },

  editYourBallot: {
    [languageOptions.english.key]: 'Edit your ballot',
    [languageOptions.spanish.key]: 'Editar tu balota',
  },

  wantToPlayAgainstAGroupOfFriends: {
    [languageOptions.english.key]: 'Want to play against a group of friends?',
    [languageOptions.spanish.key]: '¿Quieres jugar contra un grupo de amigos?',
  },

  startALeague: {
    [languageOptions.english.key]: 'Start a league',
    [languageOptions.spanish.key]: 'Lanzar una liga',
  },

  makeSureYouFinishYourBallotBeforeTheOscarsStart: {
    [languageOptions.english.key]:
      'Make sure you finish your ballot before the Oscars start!',
    [languageOptions.spanish.key]:
      '¡Llena tu balota antes del comienzo de los Oscars!',
  },

  finishYourBallot: {
    [languageOptions.english.key]: 'Finish your ballot',
    [languageOptions.spanish.key]: 'Llenar tu balota',
  },

  welcome: {
    [languageOptions.english.key]: 'Welcome',
    [languageOptions.spanish.key]: 'Bienvenid@s',
  },

  finish: {
    [languageOptions.english.key]: 'Finish',
    [languageOptions.spanish.key]: 'Completa',
  },

  fillOutYourBallot: {
    [languageOptions.english.key]: 'Fill out your ballot',
    [languageOptions.spanish.key]: 'Llenar tu balota',
  },

  seeTheNominees: {
    [languageOptions.english.key]: 'See the nominees',
    [languageOptions.spanish.key]: 'Ver los nominados',
  },

  logOut: {
    [languageOptions.english.key]: 'Log out',
    [languageOptions.spanish.key]: 'Salir',
  },

  aboutThisApp: {
    [languageOptions.english.key]: 'About this app',
    [languageOptions.spanish.key]: 'Sobre este app',
  },

  useRightHandMode: {
    [languageOptions.english.key]: 'Use right hand mode',
    [languageOptions.spanish.key]: 'Modo diestro',
  },

  useLeftHandMode: {
    [languageOptions.english.key]: 'Use left hand mode',
    [languageOptions.spanish.key]: 'Modo zurdo',
  },

  changeLanguage: {
    [languageOptions.english.key]: 'Change language',
    [languageOptions.spanish.key]: 'Cambiar el idioma',
  },

  changeAvatar: {
    [languageOptions.english.key]: 'Change avatar',
    [languageOptions.spanish.key]: 'Cambiar el avatar',
  },

  menuLetterboxd: {
    [languageOptions.english.key]: 'Connect Letterboxd',
    [languageOptions.spanish.key]: 'Conectar Letterboxd',
  },

  letterboxdSettings: {
    [languageOptions.english.key]: 'Letterboxd settings',
    [languageOptions.spanish.key]: 'Ajustes de Letterboxd',
  },

  spoilerDelay: {
    [languageOptions.english.key]: 'Spoiler delay',
    [languageOptions.spanish.key]: 'Retraso de spoilers',
  },

  spoilerDelayOff: {
    [languageOptions.english.key]: 'Off',
    [languageOptions.spanish.key]: 'Desactivado',
  },

  spoilerDelayExplanation: {
    [languageOptions.english.key]: 'If you see the results coming in too fast, you can add a delay to avoid spoilers. You can change this anytime by tapping the snail.',
    [languageOptions.spanish.key]: 'Si ves los resultados llegando demasiado rápido, puedes agregar un retraso para evitar spoilers. Puedes cambiarlo en cualquier momento tocando el caracol.',
  },

  spoilerDelayLiveDescription: {
    [languageOptions.english.key]: 'See results instantly.',
    [languageOptions.spanish.key]: 'Ver resultados al instante.',
  },

  spoilerDelayDelayDescription: {
    [languageOptions.english.key]: 'Buffer results by a set time.',
    [languageOptions.spanish.key]: 'Retrasar los resultados por un tiempo.',
  },

  delay: {
    [languageOptions.english.key]: 'Delay',
    [languageOptions.spanish.key]: 'Retraso',
  },

  none: {
    [languageOptions.english.key]: 'None',
    [languageOptions.spanish.key]: 'Ninguno',
  },

  seconds: {
    [languageOptions.english.key]: 'seconds',
    [languageOptions.spanish.key]: 'segundos',
  },

  letterboxdInstructions: {
    [languageOptions.english.key]: 'Enter your Letterboxd username below.',
    [languageOptions.spanish.key]:
      'Entra su nombre usuario de Letterboxd abajo.',
  },
  "Connect Letterboxd to sync your watched films with Fantasy Oscars.": {
    [languageOptions.english.key]: "Connect Letterboxd to sync your watched films with Fantasy Oscars.",
    [languageOptions.spanish.key]: "Conecta Letterboxd para sincronizar tus películas vistas con Fantasy Oscars."
  },

  "New": {
    [languageOptions.english.key]: "New",
    [languageOptions.spanish.key]: "Nuevo"
  },

  letterboxdDisclaimer: {
    [languageOptions.english.key]: "This app uses the Letterboxd API but is not otherwise affiliated with, endorsed, or certified by Letterboxd.",
    [languageOptions.spanish.key]: "Esta aplicación usa la API de Letterboxd pero no está afiliada, respaldada, o certificada por Letterboxd."
  },

  'Your Letterboxd account is connected.': {
    [languageOptions.english.key]: 'Your Letterboxd account is connected.',
    [languageOptions.spanish.key]: 'Tu cuenta de Letterboxd está conectada.'
  },

  'disconnect this account': {
    [languageOptions.english.key]: 'Disconnect this account',
    [languageOptions.spanish.key]: 'Desconectar esta cuenta'
  },

  'connect a different account': {
    [languageOptions.english.key]: 'Connect a different account',
    [languageOptions.spanish.key]: 'Conectar una cuenta diferente'
  },

  "Create": {
    [languageOptions.english.key]: "Create",
    [languageOptions.spanish.key]: "Crear"
  },

  toxicHandle: {
    [languageOptions.english.key]: 'Please be considerate of other players when picking your username.',
    [languageOptions.spanish.key]: 'Por favor, sé considerado con otros jugadores al elegir tu nombre de usuario.',
  },

  handleIsContactInfo: {
    [languageOptions.english.key]: 'Please use a nickname instead of your email or phone number.',
    [languageOptions.spanish.key]: 'Por favor, usa un apodo en lugar de tu correo electrónico o número de teléfono.'
  },

  handleBlocked: {
    [languageOptions.english.key]: 'This username is not allowed.',
    [languageOptions.spanish.key]: 'Este nombre de usuario no está permitido.'
  },

  handleViolationTitle: {
    [languageOptions.english.key]: 'Please choose a new username',
    [languageOptions.spanish.key]: 'Por favor elige un nuevo nombre de usuario'
  },

  handleViolationMessage: {
    [languageOptions.english.key]: 'Your previous username was removed because it may have violated our community guidelines.',
    [languageOptions.spanish.key]: 'Tu nombre de usuario anterior fue eliminado porque puede haber violado nuestras normas de la comunidad.'
  },

  handleViolationContact: {
    [languageOptions.english.key]: 'If you believe this was a mistake, reach out at',
    [languageOptions.spanish.key]: 'Si crees que esto fue un error, escríbeme a'
  },

  'hasnt started a ballot':
  {
    [languageOptions.english.key]: "hasn't started a ballot",
    [languageOptions.spanish.key]: "no ha comenzado una balota"
  },
  'havent started a ballot':
  {
    [languageOptions.english.key]: "haven't started a ballot",
    [languageOptions.spanish.key]: "no han comenzado una balota"
  },

  "Your pick": {
    [languageOptions.english.key]: "Your pick",
    [languageOptions.spanish.key]: "Tu selección"
  },

  "Done": {
    [languageOptions.english.key]: "Done",
    [languageOptions.spanish.key]: "Hecho"
  },

  "Watched": {
    [languageOptions.english.key]: "Watched",
    [languageOptions.spanish.key]: "Visto"
  },

  "Nominees": {
    [languageOptions.english.key]: "Nominees",
    [languageOptions.spanish.key]: "Nominados"
  },

  "are still setting up their profiles": {
    [languageOptions.english.key]: "are still setting up their profiles",
    [languageOptions.spanish.key]: "todavía están configurando sus perfiles"
  },

  "No Oscar nominees logged yet": {
    [languageOptions.english.key]: "No Oscar nominees logged yet",
    [languageOptions.spanish.key]: "No has registrado nominados a los Oscars"
  },

  "Badges": {
    [languageOptions.english.key]: "Badges",
    [languageOptions.spanish.key]: "Insignias"
  },

  Badge: {
    [languageOptions.english.key]: "Badge",
    [languageOptions.spanish.key]: "Insignia"
  },

  "Hmmm, we weren't able to find that letterboxd username.": {
    [languageOptions.english.key]: "Hmmm, we weren't able to find that letterboxd username.",
    [languageOptions.spanish.key]: "Hmmm, no pudimos encontrar ese nombre de usuario de Letterboxd."
  },

  changeScreenName: {
    [languageOptions.english.key]: 'Change username',
    [languageOptions.spanish.key]: 'Cambiar nombre de usuario',
  },

  onceYouReceiveYourCodeEnterItHere: {
    [languageOptions.english.key]: 'Once you receive your code, enter it here.',
    [languageOptions.spanish.key]: 'Cuando recibe tu código, ingrésalo aquí',
  },

  signIn: {
    [languageOptions.english.key]: 'Sign in',
    [languageOptions.spanish.key]: 'Acceder',
  },

  enterYourPhoneNumberAnd: {
    [languageOptions.english.key]: 'Enter your phone number and',
    [languageOptions.spanish.key]: 'Ingresa tu numero celular y',
  },

  weLlSendYouASignInCode: {
    [languageOptions.english.key]: "we'll send you a sign-in code",
    [languageOptions.spanish.key]: 'te enviamos un código para acceder',
  },

  messageAndDataRatesMayApply: {
    [languageOptions.english.key]: 'Message and data rates may apply.',
    [languageOptions.spanish.key]:
      'Se pueden aplicar tarifas por mensajes y datos.',
  },

  sendMyCode: {
    [languageOptions.english.key]: 'Send my code',
    [languageOptions.spanish.key]: 'Envíame mi código',
  },

  signingYouIn: {
    [languageOptions.english.key]: 'Signing you in',
    [languageOptions.spanish.key]: 'Iniciando sesión',
  },

  sorry: {
    [languageOptions.english.key]: 'Sorry',
    [languageOptions.spanish.key]: 'Lo sentimos',
  },

  spectating: {
    [languageOptions.english.key]: 'Spectating',
    [languageOptions.spanish.key]: 'Espectando',
  },

  spectatorMode: {
    [languageOptions.english.key]: 'Spectator Mode',
    [languageOptions.spanish.key]: 'Modo Espectador',
  },

  spectatorModeExplanation: {
    [languageOptions.english.key]:
      "Your ballot wasn't completed before the ceremony started, so you won't appear on the scoreboard. You can still follow along and watch the results!",
    [languageOptions.spanish.key]:
      'Tu boleta no se completó antes de que comenzara la ceremonia, así que no aparecerás en la tabla de posiciones. ¡Puedes seguir viendo los resultados!',
  },

  everyone: {
    [languageOptions.english.key]: 'Everyone',
    [languageOptions.spanish.key]: 'Todos',
  },

  point: {
    [languageOptions.english.key]: 'point',
    [languageOptions.spanish.key]: 'punto',
  },

  correct: {
    [languageOptions.english.key]: 'correct',
    [languageOptions.spanish.key]: 'correctas',
  },

  save: {
    [languageOptions.english.key]: 'save',
    [languageOptions.spanish.key]: 'guardar',
  },

  "That's me!": {
    [languageOptions.english.key]: "That's me!",
    [languageOptions.spanish.key]: '¡Soy yo!',
  },

  begin: {
    [languageOptions.english.key]: 'begin',
    [languageOptions.spanish.key]: 'empezar',
  },

  _continue: {
    [languageOptions.english.key]: 'Continue',
    [languageOptions.spanish.key]: 'Continuar',
  },
  _next: {
    [languageOptions.english.key]: 'Next',
    [languageOptions.spanish.key]: 'Siguiente',
  },

  getStarted: {
    [languageOptions.english.key]: 'Get Started',
    [languageOptions.spanish.key]: 'Empezar',
  },

  chooseAnAvatar: {
    [languageOptions.english.key]: 'Choose an avatar.',
    [languageOptions.spanish.key]: 'Elegir un avatar.',
  },

  enterANewUniqueScreenNameBelow: {
    [languageOptions.english.key]: 'Enter a new unique username below.',
    [languageOptions.spanish.key]: 'Ingresa un nuevo nombre de usuario único abajo.',
  },

  shootThatOneSAlreadyTaken: {
    [languageOptions.english.key]: "Shoot, that one's already taken.",
    [languageOptions.spanish.key]: '¡Uy! Este nombre ya está en uso.',
  },

  YourFavorites: {
    [languageOptions.english.key]: 'Your Favorites',
    [languageOptions.spanish.key]: 'Tus favorit@s',
  },
  Favorites: {
    [languageOptions.english.key]: 'Favorites',
    [languageOptions.spanish.key]: 'Favoritos',
  },
  Tap: {
    [languageOptions.english.key]: 'Tap',
    [languageOptions.spanish.key]: 'Toca',
  },

  _whenFillingOutYourBallotToAddFavorites: {
    [languageOptions.english.key]:
      'when filling out your ballot to add favorites',
    [languageOptions.spanish.key]:
      'cuando esté completando su balota para agregar favoritos',
  },

  Close: {
    [languageOptions.english.key]: 'Close',
    [languageOptions.spanish.key]: 'Cerrar',
  },

  tapToClear: {
    [languageOptions.english.key]: 'Tap to clear',
    [languageOptions.spanish.key]: 'Toca para borrar',
  },

  letSEditYourBallot: {
    [languageOptions.english.key]: "Let's edit your ballot.",
    [languageOptions.spanish.key]: 'Editar tu balota.',
  },

  Remove: {
    [languageOptions.english.key]: 'Remove',
    [languageOptions.spanish.key]: 'Eliminar',
  },

  DeleteLeague: {
    [languageOptions.english.key]: 'Delete league',
    [languageOptions.spanish.key]: 'Borrar liga',
  },
  Members: {
    [languageOptions.english.key]: 'Members',
    [languageOptions.spanish.key]: 'Miembros',
  },
  Manage: {
    [languageOptions.english.key]: 'Manage',
    [languageOptions.spanish.key]: 'Administrar',
  },
  Owner: {
    [languageOptions.english.key]: 'Owner',
    [languageOptions.spanish.key]: 'Dueño',
  },
  Kick: {
    [languageOptions.english.key]: 'Kick',
    [languageOptions.spanish.key]: 'Expulsar',
  },
  areYouSureYouWantToKick: {
    [languageOptions.english.key]: 'Are you sure you want to kick',
    [languageOptions.spanish.key]: '¿Estás seguro de que quieres expulsar a',
  },
  newMember: {
    [languageOptions.english.key]: 'New member',
    [languageOptions.spanish.key]: 'Nuevo miembro',
  },
  joined: {
    [languageOptions.english.key]: 'Joined',
    [languageOptions.spanish.key]: 'Se unió',
  },
  joinedIn: {
    [languageOptions.english.key]: 'Joined in',
    [languageOptions.spanish.key]: 'Se unió en',
  },
  noMembersMatch: {
    [languageOptions.english.key]: 'No members match',
    [languageOptions.spanish.key]: 'Ningún miembro coincide',
  },
  'search...': {
    [languageOptions.english.key]: 'Search...',
    [languageOptions.spanish.key]: 'Buscar...',
  },

  youCanMakeChangesUntilTheOscarsCeremonyStarts: {
    [languageOptions.english.key]:
      'You can make changes until the Oscars ceremony starts.',
    [languageOptions.spanish.key]:
      'Puedes cambiar tu balota hasta el comienzo de los Oscars.',
  },

  yourProgressWillBeSavedAutomaticallyAsYouGo: {
    [languageOptions.english.key]:
      'Your progress will be saved automatically as you go.',
    [languageOptions.spanish.key]: 'Tu progreso se guarda automaticamente.',
  },

  letSFinishUpYourBallotYouHave: {
    [languageOptions.english.key]: "Let's finish up your ballot, you have",
    [languageOptions.spanish.key]: 'Sigue llenando tu balota, tienes',
  },

  and: {
    [languageOptions.english.key]: 'and',
    [languageOptions.spanish.key]: 'y',
  },

  category: {
    [languageOptions.english.key]: 'category',
    [languageOptions.spanish.key]: 'categoría',
  },

  categories: {
    [languageOptions.english.key]: 'categories',
    [languageOptions.spanish.key]: 'categorías',
  },

  left: {
    [languageOptions.english.key]: 'left',
    [languageOptions.spanish.key]: 'restantes',
  },

  toGo: {
    [languageOptions.english.key]: 'to go',
    [languageOptions.spanish.key]: 'restantes',
  },

  letSMakeYourBallot: {
    [languageOptions.english.key]: "Let's make your ballot",
    [languageOptions.spanish.key]: 'Crea tu balota',
  },

  keepAnEyeOutForDifferentWaysToEarnPointsYouCanPredict: {
    [languageOptions.english.key]:
      'Keep an eye out for different ways to earn points. You can predict',
    [languageOptions.spanish.key]:
      'Hay muchas maneras de ganar puntos. Puedes predecir',
  },

  Winner: {
    [languageOptions.english.key]: 'Winner',
    [languageOptions.spanish.key]: 'Ganador',
  },

  winners: {
    [languageOptions.english.key]: 'winners',
    [languageOptions.spanish.key]: 'ganadores',
  },

  results: {
    [languageOptions.english.key]: 'results',
    [languageOptions.spanish.key]: 'resultados',
  },

  pass: {
    [languageOptions.english.key]: 'pass',
    [languageOptions.spanish.key]: 'saltar',
  },

  events: {
    [languageOptions.english.key]: 'events',
    [languageOptions.spanish.key]: 'sucesos',
  },

  andEven: {
    [languageOptions.english.key]: 'and even',
    [languageOptions.spanish.key]: 'y aún',
  },

  inSomeCategories: {
    [languageOptions.english.key]: 'in some categories',
    [languageOptions.spanish.key]: 'en algunas categorías',
  },

  allSet: {
    [languageOptions.english.key]: 'All set',
    [languageOptions.spanish.key]: 'Listo',
  },
  Settings: {
    [languageOptions.english.key]: 'Settings',
    [languageOptions.spanish.key]: 'Ajustes',
  },
  LeagueName: {
    [languageOptions.english.key]: 'League name',
    [languageOptions.spanish.key]: 'Nombre de la liga',
  },
  UpdateName: {
    [languageOptions.english.key]: 'Update name',
    [languageOptions.spanish.key]: 'Actualizar nombre',
  },
  completed: {
    [languageOptions.english.key]: 'completed',
    [languageOptions.spanish.key]: 'completados',
  },
  completedBallot: {
    [languageOptions.english.key]: 'completed ballot',
    [languageOptions.spanish.key]: 'boleta completada',
  },
  inProgress: {
    [languageOptions.english.key]: 'in progress',
    [languageOptions.spanish.key]: 'en progreso',
  },
  ballotInProgress: {
    [languageOptions.english.key]: 'ballot in progress',
    [languageOptions.spanish.key]: 'boleta en progreso',
  },
  notStarted: {
    [languageOptions.english.key]: 'not started',
    [languageOptions.spanish.key]: 'sin comenzar',
  },
  haventStarted: {
    [languageOptions.english.key]: "haven't started",
    [languageOptions.spanish.key]: 'no han comenzado',
  },
  hasntStartedABallot: {
    [languageOptions.english.key]: "hasn't started a ballot",
    [languageOptions.spanish.key]: 'no ha comenzado una boleta',
  },
  haventStartedBallots: {
    [languageOptions.english.key]: "haven't started ballots",
    [languageOptions.spanish.key]: 'no han comenzado boletas',
  },
  settingUp: {
    [languageOptions.english.key]: 'setting up',
    [languageOptions.spanish.key]: 'configurando',
  },
  stillSettingUp: {
    [languageOptions.english.key]: 'still setting up',
    [languageOptions.spanish.key]: 'aún configurando',
  },
  profile: {
    [languageOptions.english.key]: 'profile',
    [languageOptions.spanish.key]: 'perfil',
  },
  ballot: {
    [languageOptions.english.key]: 'ballot',
    [languageOptions.spanish.key]: 'boleta',
  },
  member: {
    [languageOptions.english.key]: 'member',
    [languageOptions.spanish.key]: 'miembro',
  },
  Created: {
    [languageOptions.english.key]: 'Created',
    [languageOptions.spanish.key]: 'Creado',
  },
  LeagueCreated: {
    [languageOptions.english.key]: 'League created',
    [languageOptions.spanish.key]: 'Liga creada',
  },

  createLeague: {
    [languageOptions.english.key]: 'Create league',
    [languageOptions.spanish.key]: 'Crear una liga',
  },

  SoFar: {
    [languageOptions.english.key]: 'So far ;)',
    [languageOptions.spanish.key]: 'Por ahora ;)',
  },

  League: {
    [languageOptions.english.key]: 'League',
    [languageOptions.spanish.key]: 'Liga',
  },
  thereSNoLeagueHereItWasProbablyDeleted: {
    [languageOptions.english.key]:
      "There's no league here! It was probably deleted.",
    [languageOptions.spanish.key]:
      '¡Aquí no hay liga! Probablemente fue borrado.',
  },

  leaveLeague: {
    [languageOptions.english.key]: 'Leave league',
    [languageOptions.spanish.key]: 'Salir tu liga',
  },

  enterANameForYourLeague: {
    [languageOptions.english.key]: 'Enter a name for your league',
    [languageOptions.spanish.key]: 'Ingresa un nombre para tu liga',
  },

  copyLinkToClipboard: {
    [languageOptions.english.key]: 'Copy link to clipboard',
    [languageOptions.spanish.key]: 'Copiar el enlace',
  },

  shareInviteLink: {
    [languageOptions.english.key]: 'Share invite link',
    [languageOptions.spanish.key]: 'Compartir el enlace de invitación',
  },

  copyInviteLink: {
    [languageOptions.english.key]: 'Copy invite link',
    [languageOptions.spanish.key]: 'Copiar el enlace de invitación',
  },

  invite: {
    [languageOptions.english.key]: 'Invite',
    [languageOptions.spanish.key]: 'Invitar',
  },

  scanToJoin: {
    [languageOptions.english.key]: 'Scan to join',
    [languageOptions.spanish.key]: 'Escanea para unirte',
  },

  areYouSureYouWantToLeave: {
    [languageOptions.english.key]: 'Are you sure you want to leave',
    [languageOptions.spanish.key]: 'Estás seguro que quieres salir',
  },

  areYouSureYouWantToDeleteThisLeague: {
    [languageOptions.english.key]:
      'Are you sure you want to delete this league? This cannot be undone.',
    [languageOptions.spanish.key]:
      '¿Estás seguro de que quieres eliminar esta liga? Esto no se puede deshacer.',
  },

  'No details available.': {
    [languageOptions.english.key]: 'No details available.',
    [languageOptions.spanish.key]: 'No hay detalles disponibles.',
  },

  'areYouSureYouWantToRemoveThisFavorite?': {
    [languageOptions.english.key]:
      'Are you sure you want to remove this favorite?',
    [languageOptions.spanish.key]:
      '¿Estás seguro de que quieres eliminar este favorito?',
  },

  joinMyFantasyOscarsLeague: {
    [languageOptions.english.key]: 'Join my Fantasy Oscars league!',
    [languageOptions.spanish.key]:
      '¡Únete a mi liga de los Oscars de Fantasia!',
  },

  otherPlayersCanJoinYourLeagueByVisitingThisLink: {
    [languageOptions.english.key]:
      'Other players can join your league by visiting this link',
    [languageOptions.spanish.key]:
      'Otros jugadores pueden unir a tu liga por visitar este enlace',
  },

  isReadyToGo: {
    [languageOptions.english.key]: 'is ready to go',
    [languageOptions.spanish.key]: 'está lista',
  },

  more: {
    [languageOptions.english.key]: 'more',
    [languageOptions.spanish.key]: 'mas',
  },

  noDelay: {
    [languageOptions.english.key]: 'No Delay',
    [languageOptions.spanish.key]: 'Sin retraso',
  },

  gotIt: {
    [languageOptions.english.key]: 'Got it',
    [languageOptions.spanish.key]: 'Entendido',
  },

  setADelay: {
    [languageOptions.english.key]: 'Set a delay',
    [languageOptions.spanish.key]: 'Agregar retraso',
  },

  tapMe: {
    [languageOptions.english.key]: 'Tap me',
    [languageOptions.spanish.key]: 'Tócame',
  },

  firstCategoryToBeAnnounced: {
    [languageOptions.english.key]: 'First category to be announced...',
    [languageOptions.spanish.key]: 'Primera categoría por anunciar...',
  },

  nextCategory: {
    [languageOptions.english.key]: 'Next category',
    [languageOptions.spanish.key]: 'Siguiente categoría',
  },

  toBeAnnounced: {
    [languageOptions.english.key]: 'To be announced.',
    [languageOptions.spanish.key]: 'Será determinada.',
  },

  wentTo: {
    [languageOptions.english.key]: 'went to',
    // Left empty, handled by above copy
    [languageOptions.spanish.key]: '',
  },

  _with: {
    [languageOptions.english.key]: 'with',
    [languageOptions.spanish.key]: 'con',
  },

  points: {
    [languageOptions.english.key]: 'points',
    [languageOptions.spanish.key]: 'puntos',
  },

  winnerIs: {
    [languageOptions.english.key]: 'And the winner is',
    [languageOptions.spanish.key]: 'y el/la ganador@ es',
  },

  winnersAre: {
    [languageOptions.english.key]: 'And the winners are',
    [languageOptions.spanish.key]: 'y los/las ganador@s son',
  },

  yourBallot: {
    [languageOptions.english.key]: 'Your ballot',
    [languageOptions.spanish.key]: 'Tu balota',
  },

  leagueOwner: {
    [languageOptions.english.key]: 'League owner',
    [languageOptions.spanish.key]: 'Dueño de la liga',
  },

  tapToEdit: {
    [languageOptions.english.key]: 'Tap to edit',
    [languageOptions.spanish.key]: 'Toca para editar',
  },

  tapToView: {
    [languageOptions.english.key]: 'Tap to view',
    [languageOptions.spanish.key]: 'Toque para ver',
  },

  tapToOpen: {
    [languageOptions.english.key]: 'Tap to open',
    [languageOptions.spanish.key]: 'Toque para abrir',
  },

  tapToViewOrEdit: {
    [languageOptions.english.key]: 'Tap to view or edit',
    [languageOptions.spanish.key]: 'Toque para ver o editar',
  },


  whatsYourPreferredLanguage: {
    [languageOptions.english.key]: 'What\'s your preferred language?',
    [languageOptions.spanish.key]: '¿Cuál es tu idioma preferido?',
  },

  nextPickAUniqueScreenName: {
    [languageOptions.english.key]: 'Pick a username',
    [languageOptions.spanish.key]: 'Escoge un nombre de usuario',
  },

  pickOneForMe: {
    [languageOptions.english.key]: 'Pick one for me',
    [languageOptions.spanish.key]: 'Elige uno por mí',
  },

  generateAnother: {
    [languageOptions.english.key]: 'Generate another',
    [languageOptions.spanish.key]: 'Generar otro',
  },

  lastYouCanCustomizeYourAvatar: {
    [languageOptions.english.key]: 'Select an avatar',
    [languageOptions.spanish.key]: 'Selecciona un avatar',
  },

  joiningLeague: {
    [languageOptions.english.key]: 'Joining league',
    [languageOptions.spanish.key]: 'Uniendo la liga',
  },

  signInToJoin: {
    [languageOptions.english.key]: 'Sign in to join',
    [languageOptions.spanish.key]: 'Inicia sesión para unirte a',
  },

  troubleJoiningLeague: {
    [languageOptions.english.key]: 'We had trouble joining',
    [languageOptions.spanish.key]: 'Tuvimos problemas al unirte a',
  },

  tryAgain: {
    [languageOptions.english.key]: 'Try again',
    [languageOptions.spanish.key]: 'Intentar de nuevo',
  },

  returnToHome: {
    [languageOptions.english.key]: 'Return to home',
    [languageOptions.spanish.key]: 'Volver al inicio',
  },

  pointsEveryTime: {
    [languageOptions.english.key]: 'points every time',
    [languageOptions.spanish.key]: 'puntos cada vez',
  },

  pointsIf: {
    [languageOptions.english.key]: 'points if',
    [languageOptions.spanish.key]: 'puntos si',
  },

  pointsNoMatterWhat: {
    [languageOptions.english.key]: 'points no matter what',
    [languageOptions.spanish.key]: 'puntos automáticos',
  },

  pointsIfThisNomineeWins: {
    [languageOptions.english.key]: 'points if this nominee wins',
    [languageOptions.spanish.key]: 'puntos si este nominado gane',
  },

  'Buy me a coffee': {
    [languageOptions.english.key]: 'Buy me a coffee',
    [languageOptions.spanish.key]: 'Cómprame un café',
  },

  _Pass: {
    [languageOptions.english.key]: 'Pass',
    [languageOptions.spanish.key]: 'Saltar',
  },

  _For: {
    [languageOptions.english.key]: 'For',
    [languageOptions.spanish.key]: 'Por',
  },

  aWinnerThanksTheAcademyOneOrMoreTimesInTheirAcceptanceSpeech: {
    [languageOptions.english.key]:
      'A winner thanks the Academy one or more times in their acceptance speech.',
    [languageOptions.spanish.key]:
      'Un/a ganador@ agradece a la Academia en su discurso de aceptación.',
  },

  aWinnerThanksTheirMotherOneOrMoreTimesInTheirAcceptanceSpeech: {
    [languageOptions.english.key]:
      'A winner thanks their mother one or more times in their acceptance speech.',
    [languageOptions.spanish.key]:
      'Un/a ganador@ agradezca a su mamá en su discurso de aceptación.',
  },

  aWinnerThanksADivinePowerOneOrMoreTimesInTheirAcceptanceSpeech: {
    [languageOptions.english.key]:
      'A winner thanks a divine power one or more times in their acceptance speech.',
    [languageOptions.spanish.key]:
      'Un/a ganador@ agradezca a un poder divino en su discurso de aceptación.',
  },

  aWinnerContinuesTheirAcceptanceSpeechOverTheOrchestraForAtLeastTenSecond: {
    [languageOptions.english.key]:
      'A winner continues their acceptance speech over the orchestra for at least ten seconds.',
    [languageOptions.spanish.key]:
      'Un/a ganador@ continúa su discurso de aceptación durante al menos diez segundos mientras toca la orquesta.',
  },

  theWrongWinnerIsAnnouncedInAnyCategory: {
    [languageOptions.english.key]:
      'The wrong winner is announced in any category.',
    [languageOptions.spanish.key]:
      'El/la locutor@ anuncie un/a ganador@ equivocad@.',
  },

  StrictScoring: {
    [languageOptions.english.key]: 'Strict scoring',
    [languageOptions.spanish.key]: 'Puntuación estricta',
  },

  StrictScoringIsOn: {
    [languageOptions.english.key]: 'Strict scoring is on',
    [languageOptions.spanish.key]: 'La puntuación estricta está activada',
  },

  strictScoringExplanation: {
    [languageOptions.english.key]:
      'When strict scoring is toggled on for your league, only correct winner guesses are counted towards point totals. Points for special categories like "Shout outs" and "Pass" selections are ignored.',
    [languageOptions.spanish.key]:
      'Cuando la puntuación estricta está activada para su liga, solo las conjeturas ganadoras correctas se cuentan para el total de puntos. Los puntos para categorías especiales como "Shout outs" y las selecciones "Pass" se ignoran.',
  },

  strictScoringCategoryItemExplanation: {
    [languageOptions.english.key]:
      "You're in a league that only counts points for correctly guessing the winner. You may want to select a nominee option.",
    [languageOptions.spanish.key]:
      'Estás en una liga que solo cuenta puntos por adivinar correctamente el ganador. Es posible que desee seleccionar una opción de candidato.',
  },

  ScoringMode: {
    [languageOptions.english.key]: 'Scoring mode',
    [languageOptions.spanish.key]: 'Modo de puntuación',
  },

  Default: {
    [languageOptions.english.key]: 'Default',
    [languageOptions.spanish.key]: 'Estándar',
  },

  Strict: {
    [languageOptions.english.key]: 'Strict',
    [languageOptions.spanish.key]: 'Estricto',
  },

  scoringModeDefaultDescription: {
    [languageOptions.english.key]: 'Recommended. Weighted points and fun extras.',
    [languageOptions.spanish.key]: 'Recomendado. Puntos ponderados y extras divertidos.',
  },

  scoringModeStrictDescription: {
    [languageOptions.english.key]: 'One point per category. No passes.',
    [languageOptions.spanish.key]: 'Un punto por categoría. Sin pases.',
  },

  teachersPet: {
    [languageOptions.english.key]: "Teacher's Pet",
    [languageOptions.spanish.key]: 'El Favorito del Profe',
  },

  mooooom: {
    [languageOptions.english.key]: 'Mooooom',
    [languageOptions.spanish.key]: 'Mooooom',
  },

  divineIntervention: {
    [languageOptions.english.key]: 'Divine Intervention',
    [languageOptions.spanish.key]: 'Intervención Divina',
  },

  pipeDown: {
    [languageOptions.english.key]: 'Pipe Down',
    [languageOptions.spanish.key]: 'Hace Shh',
  },

  laLaLand: {
    [languageOptions.english.key]: 'La La Land',
    [languageOptions.spanish.key]: 'La La Land',
  },

  netflixWin: {
    [languageOptions.english.key]: 'Netflix Win',
    [languageOptions.spanish.key]: 'Una Victoria Netflix',
  },

  niиWin: {
    [languageOptions.english.key]: 'NIИ Win',
    [languageOptions.spanish.key]: 'Una Victoria NIИ',
  },

  leslieOdomJrWin: {
    [languageOptions.english.key]: 'Leslie Odom, Jr. Win',
    [languageOptions.spanish.key]: 'Una Victoria para Leslie Odom, Jr.',
  },

  appCrashed: {
    [languageOptions.english.key]:
      "Oh no, we crashed! Let's see if reloading fixes the issue.",
    [languageOptions.spanish.key]:
      '¡Uy - La aplicación falló! A ver si recargando se soluciona.',
  },

  'If this keeps happening, please': {
    [languageOptions.english.key]: 'If this keeps happening, please',
    [languageOptions.spanish.key]: 'Si esto sigue sucediendo, por favor',
  },

  'Email me': {
    [languageOptions.english.key]: 'Email me',
    [languageOptions.spanish.key]: 'envíeme un mensaje',
  },

  _Reload: {
    [languageOptions.english.key]: 'Reload',
    [languageOptions.spanish.key]: 'Recargar',
  },

  'Crash scene from "Chitty Chitty Bang Bang"': {
    [languageOptions.english.key]: 'Crash scene from "Chitty Chitty Bang Bang"',
    [languageOptions.spanish.key]:
      'Una foto de un accidente automovilístico de la película "Chitty Chitty Bang Bang"',
  },

  'Yes': {
    [languageOptions.english.key]: 'Yes',
    [languageOptions.spanish.key]: 'Sí',
  },

  'Nope': {
    [languageOptions.english.key]: 'Nope',
    [languageOptions.spanish.key]: 'No',
  },

  'No': {
    [languageOptions.english.key]: 'No',
    [languageOptions.spanish.key]: 'No',
  },

  'Message and data rates may apply': {
    [languageOptions.english.key]: 'Message and data rates may apply.',
    [languageOptions.spanish.key]: 'Se pueden aplicar tarifas por mensajes y datos.',
  },

  'You can update this in settings anytime.': {
    [languageOptions.english.key]: 'You can update this in settings anytime.',
    [languageOptions.spanish.key]: 'Puedes cambiar esto en ajustes en cualquier momento.',
  },

  ballotReminder: {
    [languageOptions.english.key]: (year: number) => `This setting tells me whether to send you a notification in ${year} when Fantasy Oscars is live.`,
    [languageOptions.spanish.key]: (year: number) => `Este ajuste me dice si enviarte una notificación en ${year} cuando Fantasy Oscars esté en vivo.`,
  },

  ballotReminderOff: {
    [languageOptions.english.key]: 'Ballot Reminder Off',
    [languageOptions.spanish.key]: 'Recordatorio de balota apagado',
  },

  ballotReminderOn: {
    [languageOptions.english.key]: 'Ballot Reminder On',
    [languageOptions.spanish.key]: 'Recordatorio de balota encendido',
  },

  lastUsed: {
    [languageOptions.english.key]: 'Last used',
    [languageOptions.spanish.key]: 'Último usado',
  },

  avatarTipSmokeStack: {
    [languageOptions.english.key]: 'Try selecting a blue or red background',
    [languageOptions.spanish.key]: 'Prueba seleccionar un fondo azul o rojo',
  },

  wrapTurnOnReminder: {
    [languageOptions.english.key]: 'Turn on ballot reminder',
    [languageOptions.spanish.key]: 'Activar recordatorio de balota',
  },

  wrapBuyMeACoffee: {
    [languageOptions.english.key]: 'Buy me a coffee!',
    [languageOptions.spanish.key]: '¡Invítame un café!',
  },

  wrapCongratsFirstTime: {
    [languageOptions.english.key]: 'Congrats on your first Fantasy Oscars.',
    [languageOptions.spanish.key]: 'Felicidades por tu primer Fantasy Oscars.',
  },

  wrapHopeToSeeBallot: {
    [languageOptions.english.key]: 'Hope to see your ballot next year.',
    [languageOptions.spanish.key]: 'Esperamos ver tu balota el próximo año.',
  },

  wrapHopeToSeeYou: {
    [languageOptions.english.key]: 'Hope to see you next year.',
    [languageOptions.spanish.key]: 'Esperamos verte el próximo año.',
  },

  wrapHopeToSeeYouAgain: {
    [languageOptions.english.key]: 'Hope to see you again next year.',
    [languageOptions.spanish.key]: 'Esperamos verte de nuevo el próximo año.',
  },

} as const;

export type SingleLanguageCopyType = {
  getOtherUserBallotMessage: (args: { handle: string }) => string;
  getOtherUserFavoritesMessage: (args: { handle: string }) => string;
  getYearEdition: (args: { year: string | number }) => string;
  ballotNotReadyToFillMessage: (args: { year: string | number }) => string;
  ['Do you want a notification?']: (args: { authMethod?: string }) => string;
  ["That's a wrap!"]: (args: { year: string | number }) => string;
  ballotReminder: (year: number) => string;
  wrapThanksStreak: (args: { count: number }) => string;
  wrapThanksNoStreak: (args: { count: number }) => string;
  wrapReminderOn: (args: { year: number }) => string;
} & Omit<Record<keyof typeof copy, string>, 'ballotReminder'>;

let copyWithGetters = {
  ...copy,
  getOtherUserBallotMessage: {
    [languageOptions.english.key]: ({ handle }: { handle: string }) =>
      `${handle}'s ballot`,
    [languageOptions.spanish.key]: ({ handle }: { handle: string }) =>
      `la balota de ${handle}`,
  },
  getOtherUserFavoritesMessage: {
    [languageOptions.english.key]: ({ handle }: { handle: string }) =>
      `${handle}'s favorites`,
    [languageOptions.spanish.key]: ({ handle }: { handle: string }) =>
      `Los favoritos de ${handle}`,
  },
  getYearEdition: {
    [languageOptions.english.key]: ({ year }: { year: string | number }) =>
      `${year} edition`,
    [languageOptions.spanish.key]: ({ year }: { year: string | number }) =>
      `Edición ${year}`,
  },
  ballotNotReadyToFillMessage: {
    [languageOptions.english.key]: ({ year }: { year: string | number }) =>
      `The ${year} Oscars ballot will be ready soon!`,
    [languageOptions.spanish.key]: ({ year }: { year: string | number }) =>
      `¡La balota de los Oscars ${year} estará lista pronto!`,
  },
  ["That's a wrap!"]: {
    [languageOptions.english.key]: ({ year }: { year: string | number }) =>
      `That's a wrap on Fantasy Oscars ${year}!`,
    [languageOptions.spanish.key]: ({ year }: { year: string | number }) =>
      `¡Fantasy Oscars ${year} ha terminado!`,
  },
  ['Do you want a notification?']: {
    [languageOptions.english.key]: ({ authMethod, year }: { authMethod: string, year: string | number }) =>
      `Do you want ${authMethod === 'phone' ? 'a text' : 'an email'
      } when Fantasy Oscars ${year} is live?`,
    [languageOptions.spanish.key]: ({ authMethod, year }: { authMethod: string, year: string | number }) =>
      `¿Quieres recibir un ${authMethod === 'phone' ? 'mensaje' : 'correo'
      } cuando Fantasy Oscars ${year} esté listo?`,
  },
  wrapThanksStreak: {
    [languageOptions.english.key]: ({ count }: { count: number }) =>
      `Thanks for joining us ${count} years running.`,
    [languageOptions.spanish.key]: ({ count }: { count: number }) =>
      `Gracias por unirte ${count} años consecutivos.`,
  },
  wrapThanksNoStreak: {
    [languageOptions.english.key]: ({ count }: { count: number }) =>
      `Thanks for joining us a ${getEnglishOrdinal(count)} time.`,
    [languageOptions.spanish.key]: ({ count }: { count: number }) =>
      `Gracias por unirte por ${count}ª vez.`,
  },
  wrapReminderOn: {
    [languageOptions.english.key]: ({ year }: { year: number }) =>
      `${year} reminder on`,
    [languageOptions.spanish.key]: ({ year }: { year: number }) =>
      `Recordatorio ${year} activado`,
  },
} as const;

export default copyWithGetters;

